import { render, staticRenderFns } from "./NotificationByStaffModal.html?vue&type=template&id=1a203c60&external"
import script from "./NotificationByStaffModal.ts?vue&type=script&lang=ts&external"
export * from "./NotificationByStaffModal.ts?vue&type=script&lang=ts&external"
import style0 from "./NotificationByStaffModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports